module.exports = __webpack_public_path__ + "img/standardYQGZYL.cad20b55.png";